import React, { createContext, useState, ReactNode, useMemo } from 'react';

interface SearchContextType {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

export const SearchContext = createContext<SearchContextType | null>(null);

interface SearchProviderProps {
  children: ReactNode;
}

export const SearchProvider: React.FC<SearchProviderProps> = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const contextValue = useMemo(() => ({ searchTerm, setSearchTerm }), [searchTerm]);

  return <SearchContext.Provider value={contextValue}>{children}</SearchContext.Provider>;
};
